<template>
  <div class="right_box_main">
    <!-- 面包屑导航 -->
    <div class="mianbao">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/griddingindex' }">网格工作</el-breadcrumb-item>
        <el-breadcrumb-item>社区议事协商共治</el-breadcrumb-item>
        <el-breadcrumb-item>社区共治委员会</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="card-box">
      <!-- 右边卡片 -->
      <div class="card-rb">
        <div class="card-4">
          <el-card :body-style="{ padding: '16px' }">
            <div id="chartss1" style="height:150px;width:100%;">
              <el-divider>组织基本信息</el-divider>
              <div class="cli">组织名称：{{zzInform.name}}</div>
              <div class="cli">所属社区：{{zzInform.gridName}}</div>
              <div class="cli">创建人：{{zzInform.creater}}</div>
              <div class="cli">联系方式：{{zzInform.contactInfo}}</div>
            </div>
            <div class="fisthang">
              <el-divider>组织人员信息</el-divider>
            </div>
            <div class="three">
              <el-button type="primary" size="mini" @click="back">返回</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="showDialogForm('','add')"
              >新增</el-button>
              <!-- <el-button type="danger" size="mini">导出Excel</el-button> -->
            </div>
            <!-- 表格盒子 -->
            <div class="table_card">
              <el-table
                :data="tableData"
                :header-cell-style="{ background: '#f8fafa' }"
                border
                align="center"
                current-row-key
                highlight-current-row
              >
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column type="index" align="center" label="序号"></el-table-column>
                <el-table-column align="center" prop="name" label="姓名"></el-table-column>
                <el-table-column align="center" prop="sex" label="性别">
                  <template scope="scope">
                    <span v-if="scope.row.sex == '0'">男</span>
                    <span v-if="scope.row.sex == '1'">女</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="age" label="年龄"></el-table-column>
                <el-table-column align="center" prop="politicalOutlook" label="政治面貌">
                  <template scope="scope">
                    <span v-if="scope.row.politicalOutlook == '1'">正式党员</span>
                    <span v-if="scope.row.politicalOutlook == '2'">预备党员</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
                <el-table-column align="center" prop="parentPersonTypeName" label="类别"></el-table-column>
                <!-- <el-table-column
                  align="center"
                  prop="personType"
                  label="人员大类"
                  :formatter="formatterPersonType"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="personType"
                  label="人员小类"
                  :formatter="formatterPersonType1"
                ></el-table-column> -->
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                      <button
                        class="iconfont icon-icon7 tabBtn"
                        @click="showdeletepanduan(scope.row.id)"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageConfig.pageNo"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageConfig.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageConfig.total"
              ></el-pagination>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹出框新增/修改/查看 -->
    <el-dialog title="添加人员类别" :visible.sync="showadd" width="900px" :before-close="clearadddata">
      <el-form :inline="true" :model="searchRylist" class="demo-form-inline" size="mini">
        <!-- <el-form-item label="人员类别:" style="margin:0 30 0 0;">
          <el-select
            v-model="searchRylist.parentPersonTypeId"
            placeholder="---请选择上级类别--"
            @change="personTypeChange"
          >
            <el-option
              v-for="item in searchGroups"
              :key="item.id"
              :label="item.consultName"
              :value="item.id"
            ></el-option>
          </el-select>--
          <el-select v-model="searchRylist.personTypeId" placeholder="---请选择类别名称--">
            <el-option
              v-for="item in searchGroupsChild"
              :key="item.id"
              :label="item.consultName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="姓名:">
          <el-input v-model="searchRylist.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="searchRylist.phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRylistdata">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="searchlistReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="personListData"
        :header-cell-style="{ background: '#f8fafa' }"
        border
        align="center"
        current-row-key
        highlight-current-row
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="sex" label="性别"></el-table-column>
        <el-table-column align="center" prop="numberId" label="身份证号"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageConfig1.pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageConfig1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConfig1.total"
      ></el-pagination>
      <div class="boontbtn">
        <el-button type="primary" size="small" style="margin: 0 30px" @click="addPerson">保存</el-button>
        <el-button type="info" size="small" @click="showadd = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { addPersonList, deletePerson, changeInfor } from "@/api/api";
import { log } from "util";
import echarts_msg from "../../../utils/echarts.js";
import request from "../../../utils/request.js";
import { getTypeById_p, getConsulTYpePersion } from "@/api/http.js";
import upimg from "@/components/uploadImg/index.vue";
let token = JSON.parse(window.localStorage.getItem("user"));
import { quillEditor } from "vue-quill-editor";
import editor_option from "@/utils/editorOption.js";
import G6 from "@antv/g6";
import { post } from "@/api/requrestHttp.js";
export default {
  data() {
    return {
      zzInform:{},
      ids: [],
      personListData: [],
      searchRylist: {},
      searchGroups: [],
      searchGroupsChild: [],
      // 富文本配置
      editorOption: editor_option.editorOption,
      dialogTitle: "新增",
      // 新增弹出层
      showadd: false,
      showDisabled: false,
      addform: {
        photoPath: "",
        photoPath: "",
        parentPersonTypeId: "", //人员大类类别
        personTypeId: "", // 人员小类类别
        consultType: "",
        name: "",
        sex: "",
        numberId: "",
        phone: "",
        resume: "",
        enclosure: "",
        status: ""
      },
      rules: {
        parentPersonTypeId: [
          {
            required: true,
            message: "请选择上级类别",
            trigger: "change"
          }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        numberId: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            type: "number",
            min: 0,
            message: "必须为数字值",
            trigger: "blur"
          }
        ],
        // major: [
        //     { required: true, message: "请选择专业", trigger: "blur" }
        // ],
        resume: [
          {
            required: true,
            message: "请输入人员简历",
            trigger: "blur"
          },
          {
            max: 300,
            message: "输入字符长度少于300字符",
            trigger: "blur"
          }
        ],
        photoPath: [{ required: true, message: "请上传照片", trigger: "blur" }],
        status: [
          {
            required: true,
            message: "请选择启动状态",
            trigger: "change"
          }
        ]
      },
      //弹出框审核
      showaudit: false,
      searchlist: {},
      //专业
      searchTypes: [],
      //人员类别
      searchGroups: [],
      searchGroupsChild: [],
      //维护时需转换的字段
      fileList: [],
      majors: [],
      //表格数据
      tableData: [],
      // 分页配置
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      pageConfig1: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      readyOnly: false,
      showType: "",
      uploadUrl: request.defaults.baseURL + "/consulType/info/uplodfile",
      uploadMoreUrl: request.defaults.baseURL + "/consulType/info/uplodfiles"
    };
  },
  created(){
    let data = {};
    data.id = this.$route.query.id;
    post("/admin/consulOrg/info/getConsultOrg",data).then(res => {
      this.zzInform = res.content
      console.log(this.zzInform)
    })
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    //添加人员列表
    addPerson() {
      // let data = {};
      // data.ids = this.ids;
      // data.governanceCommitteeFlag = "1";
      // addPersonList(data).then(res => {
      //   this.showadd = false;
      //   this.$message.success(res.message);
      //   this.getPageDatas();
      // });
      post("admin/consulOrgPerson/info/batchUpdate",{
        consultPersonIds: this.ids,
        consultOrgId: this.$route.query.id
      }).then(res => {
        this.showadd = false;
        this.$message.success(res.message);
        this.getPageDatas();
      })
    },
    selectionChange(val) {
      //console.log("select",val);
      let ids = [];
      if (val) {
        val.forEach(element => {
          ids.push(element.id);
        });
        this.ids = ids;
        //console.log(ids)
      }
    },
    async getPersonList() {
      // var res = await getConsulTYpePersion({
      //   ...this.searchRylist,
      //   pageNo: this.pageConfig1.pageNo,
      //   pageSize: this.pageConfig1.pageSize,
      //   approvalStatus: 1
      // });
      // if (res.code == 200) {
      //   console.log(res);
      //   this.personListData = res.content.list;
      //   this.pageConfig1.total = res.content.count;
      // }
      post("/admin/consulType/info/findConsultPersonList",{
        ...this.searchRylist,
        pageNo: this.pageConfig1.pageNo,
        pageSize: this.pageConfig1.pageSize,
        approvalStatus: 1
      }).then(res => {
          console.log(res);
          this.personListData = res.content.list;
          this.pageConfig1.total = res.content.count;
      })
    },
    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999
        // parentId: 0
      });
      //   console.log(res);
      if (res.content) {
        this.searchGroups = res.content.list || [];
      }
    },
    //点击人员查询
    searchRylistdata() {
      this.getPersonList();
    },
    //人员类别改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1
      });
      if (res.content) {
        this.searchGroupsChild = res.content.list || [];
      }
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    searchlistReset() {
      this.searchRylist = {};
      this.pageConfig.pageNo = 1;
      this.getPersonList();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    handleCurrentChange1(val) {
      this.pageConfig1.pageNo = val;
      this.getPersonList();
    },
    //每页展示条数
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      this.pageConfig.pageNo = 1;
      this.getPageDatas();
    },
    handleSizeChange1(val) {
      //console.log(`每页 ${val} 条`);
      this.pageConfig1.pageSize = val;
      this.pageConfig1.pageNo = 1;
      this.getPersonList();
    },
    //获取列表数据
    async getPageDatas() {
      // var res = await getConsulTYpePersion({
      //   ...this.pageConfig,
      //   ...this.searchlist,
      //   governanceCommitteeFlag: 1
      // });
      // if (res.code == 200) {
      //   // console.log(">>>>>>", res);
      //   this.pageConfig.total = res.content.count;
      //   this.tableData = res.content.list;
      // } else {
      //   console.log(res);
      //   this.$message({
      //     message: "数据加载异常：",
      //     type: "error"
      //   });
      // }
      post("admin/consulOrgPerson/info/listConsultOrgPerson",{
        ...this.pageConfig,
        ...this.searchlist,
        consultOrgId: this.$route.query.id
      }).then(res => {
        this.pageConfig.total = res.content.count;
        this.tableData = res.content.list;
      })
    },
    //改变状态
    async changeStatus(cdata) {
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify(cdata);
      if (params != "{}") {
        fd.append("ConsultPerson", params);
      }

      var res = await request({
        url: "/admin/consulType/info/insertConsultPerson",
        method: "POST",
        data: fd
      });

      // console.log(res)
      var msg = "状态";
      msg = msg + (cdata.status == "0" ? "启用" : "禁用");
      if (res.code == 200) {
        this.$message({
          message: msg + "成功",
          type: "success"
        });
      } else {
        console.log(res.message);
        this.$message({
          message: msg + "失败",
          type: "error"
        });
      }
    },
    //改变状态
    async personTypeChange(ids) {
      let res = await getTypeById_p({
        parentId: ids,
        pageSize: 9999,
        pageNo: 1
      });
      if (res.content) {
        this.searchGroupsChild = res.content.list || [];
      }
    },
    async showDialogForm(id, flag) {
      //编辑
      this.showType = flag;
      if (id != "") {
        if (flag == "edit") {
          this.dialogTitle = "编辑";
          this.showadd = true;
          this.readyOnly = false;
        } else if (flag == "detail") {
          this.dialogTitle = "查看";
          //   this.showDisabled = true;
          //   this.showaudit = true;
          this.showadd = true;
          this.readyOnly = true;
        } else if (flag == "audit") {
          this.dialogTitle = "审批";
          //   this.showDisabled = false;
          //   this.showaudit = true;
          this.showadd = true;
          this.readyOnly = true;
        }
        //获取编辑项的最新数据
        let fd = new FormData();
        fd.append("token", token);
        fd.append("id", id);
        var res = await request({
          url: "/admin/consulType/info/findConsultPersonById",
          method: "POST",
          data: fd
        });
        // console.log(res)
        if (res.code == 200) {
          res.content.phone = Number(res.content.phone);
          if (flag == "audit") {
            res.content.approvalOpinion = res.content.approvalOpinion || "";
            res.content.approvalStatus = res.content.approvalStatus
              ? res.content.approvalStatus
              : "1";
          }
          this.addform = res.content;

          this.fileList = [];
          var temp = {};
          if (res.content.enclosurePath) {
            var namesArr = [];
            if (res.content.enclosureName) {
              namesArr = res.content.enclosureName.split(",");
            }

            var enclosureArr = res.content.enclosurePath.split(",");
            enclosureArr.forEach((item, index) => {
              if (item != "") {
                temp = {
                  name: namesArr[index] ? namesArr[index] : "附件" + index,
                  url: item
                };
                this.fileList.push(temp);
              }
            });
          }
        } else {
          //   console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据加载异常",
            type: "error"
          });
          this.showadd = false;
          this.showaudit = false;
        }
      } else {
        this.showadd = true;
        this.dialogTitle = "新增";
        this.getPersonList();
        // console.log(this.$refs.addform);
      }
    },
    handleExceed(files, fileList) {
      var selected = files.length;
      var totalselected = selected + fileList.length;
      this.$message.warning(
        "当前限制选择3个文件，本次选择了" +
          selected +
          "个文件，共选择了" +
          totalselected +
          "个文件"
      );
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    uploadSuccess(response, file, fileList) {
      // console.log(response)
      if (
        response.code == 200 &&
        response.content != "" &&
        response.content != null
      ) {
        this.addform.photoName = response.content.name;
        this.addform.photoPath = response.content.path;
      }
    },
    //确保每次只能上传一个文件，可多次上传
    uploadSuccessMore(response, file, fileList) {
      if (
        response.code == 200 &&
        response.content != "" &&
        response.content != null
      ) {
        this.fileList.push({
          name: response.content.name,
          url: response.content.path
        });
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //附件预览
    handlePreview(file) {
      window.open(file.url);
    },
    addformClick() {
      this.$refs.addform.validate(valid => {
        if (valid) {
          this.saveadddata();
        } else {
          //   console.log("error submit!!");
          return false;
        }
      });
    },
    //获取新增所有数据发请求
    async saveadddata() {
      let fd = new FormData();
      fd.append("token", token);
      //对多选的专业进行数组转字符串
      if (this.majors.length > 0) {
        this.addform.major = this.majors.join("/");
      }
      if (this.fileList.length > 0) {
        this.addform.enclosurePath = "";
        this.addform.enclosureName = "";
        this.fileList.forEach(item => {
          this.addform.enclosurePath =
            this.addform.enclosurePath + "," + item.url;
          this.addform.enclosureName =
            this.addform.enclosureName + "," + item.name;
        });
      }
      let params = JSON.stringify(this.addform);
      if (params == "{}") {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false;
      }
      fd.append("ConsultPerson", params);
      console.log(params);
      var res = await request({
        url: "/admin/consulType/info/insertConsultPerson",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success"
        });
        this.showadd = false;
        this.pageConfig.pageNo = 1;
        this.getPageDatas();
      } else {
        console.log(res);
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error"
        });
      }
    },
    //审批接口
    async saveAuditdata() {
      if (!this.addform.approvalStatus || !this.addform.approvalOpinion) {
        this.$message({
          message: "保存数据为空",
          type: "error"
        });
        return false;
      }
      let fd = new FormData();
      fd.append("token", token);
      let params = JSON.stringify({
        id: this.addform.id,
        approvalStatus: this.addform.approvalStatus,
        approvalOpinion: this.addform.approvalOpinion
      });
      fd.append("ConsultPerson", params);
      console.log(params);
      var res = await request({
        url: "/admin/consulType/info/approvalConsultPerson",
        method: "POST",
        data: fd
      });
      if (res.code == 200) {
        this.$message({
          message: this.dialogTitle + "成功",
          type: "success"
        });
        // this.showaudit = false;
        this.showadd = false;
        this.pageConfig.pageNo = 1;
        this.getPageDatas();
      } else {
        console.log(res);
        this.$message({
          message: this.dialogTitle + "失败：" + res.message,
          type: "error"
        });
      }
    },
    // 新增弹出框重置
    clearadddata() {
      this.showadd = false;
    },
    //根据身份证号码截取出生年月
    fullBirthday() {
      if (this.addform.numberId != undefined) {
        let iden = this.addform.numberId;
        let birth = "";
        if (iden.length === 18) {
          birth =
            iden.substring(6, 10) +
            "-" +
            iden.substring(10, 12) +
            "-" +
            iden.substring(12, 14);
        }
        if (iden.length === 15) {
          birth =
            "19" +
            iden.substring(6, 8) +
            "-" +
            iden.substring(8, 10) +
            "-" +
            iden.substring(10, 12);
        }
        this.$set(this.addform, "birthday", birth);
      }
    },

    //删除操作
    async showdeletepanduan(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          // let fd = new FormData();
          // let obj = {};
          // obj.id = id;
          // obj.governanceCommitteeFlag = "0";
          // let params = JSON.stringify(obj);
          // fd.append("ConsultPerson", params);
          // deletePerson(fd).then(res => {
          //   this.$message.success(res.message);
          //   this.getPageDatas();
          // });
          //console.log(123)
          post("admin/consulOrgPerson/info/deleteConsultOrgPerson",{
            id: id
          }).then(res => {
            console.log(123)
            this.getPageDatas()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //获取人员类别树状图
    async getPTypes() {
      var res = await getTypeById_p({
        pageNo: 1,
        pageSize: 9999
        // parentId: 0
      });
      //   console.log(res);

      if (res.content) {
        this.searchGroups = res.content.list || [];
      }
    },
    formatterPersonType(row, column) {
      return row.parentPersonTypeName;
    },
    formatterPersonType1(row, column) {
      return row.personTypeName;
    }
  },
  mounted() {
    this.getPTypes();
    this.getPageDatas();
    let data = {
      id: "社区党委书记",
      children: [
        {
          id: "社区居委会主任",
          children: [
            { id: "两委代表" },
            { id: "两新代表" },
            { id: "两代表一委员" },
            { id: "居民监督委员会代表" }
          ]
        },
        {
          id: "社区党委副书记",
          children: [
            { id: "业委会代表" },
            { id: "物业企业代表" },
            { id: "专业人士代表" },
            { id: "利益方" }
          ]
        }
      ]
    };
  },

  components: {
    upimg,
    quillEditor
  }
};
</script>

<style lang="less" scoped>
.cli{
  width: 50%;
  height: 50px;
  float: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 550;
  font-size: 18px;
}
.el-divider__text{
  font-weight: 600;
  font-size: 20px;
}
//  包裹两个卡片的盒子
.card-box {
  display: flex;
  // 左边树状列表卡片
  .card-l {
    width: 270px;
  }
  .card-r {
    // overflow: hidden;
    flex: 1;
    height: 320px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-0 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-2 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        // background-color: red;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .card-3 {
      width: 32.5%;
      height: 320px;
      .onebuttom {
        height: 258px;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .topbarnav {
      display: flex;
      align-items: center;
      div {
        box-sizing: border-box;
        padding: 0 10px;
        font-size: 14px;
      }
    }
  }
}
.card-4 {
  margin-top: 12px;
}
// 表格的盒子
.table_card {
  // overflow: hidden;
  // 解决表格无法自适应宽度
  // width: calc(100vw - 500px);
  margin: 16px 0 0 0;
  .el-table {
    width: 100%;
    // 表格里的按钮
    .tabBtn {
      margin: 0 6px;
    }
    .tabBtn:nth-child(1) {
      color: #199b5d;
      font-size: 22px;
    }
    .tabBtn:nth-child(2) {
      color: #ff04ed;
      // font-size: 25px;
    }
    .tabBtn:nth-child(3) {
      color: #dd3020;
      // font-size: 25px;
    }
    .tabBtn:nth-child(5) {
      color: #e400ff;
      font-size: 22px;
    }
    .tabBtn:nth-child(4) {
      color: #2e99cf;
      // font-size: 25px;
    }
    .active_Btn {
      color: #ff04ed !important;
      // font-size: 25px;
    }
  }
}

.download {
  .color {
    height: 25px;
    line-height: 25px;
    padding-left: 20px;
    background-color: #cdcdcd;
  }
  p {
    margin: 10px 0 10px 0;
    padding-left: 20px;
    a {
      color: #01aaef;
    }
  }
}
.threestyleimg {
  display: flex;
  // align-items: center;
  // justify-content: center;
  flex-wrap: wrap;
  .threestyleimgtu {
    width: 80%;
    height: 70%;
    margin-bottom: 20px;
    // background-color: red;
    display: flex;
    // justify-content: center;
    // align-items: center;
  }
  .threestyleimgbtn {
    width: 80%;
    height: 30%;
    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
      width: 170px;
      height: 30%;
      background: #ffffff;
      border: 1px solid #cad4dc;
      text-align: center;
      line-height: 30px;
    }
    input {
      position: absolute;
      width: 172px;
      height: 32px;
      opacity: 0;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>